import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import SectionTitle from "../common/SectionTitle";
import QuarriesCard from "./QuarriesCard";

function QuarriesAntalyaElmali1() {
  const { t } = useTranslation();

  return (
    <section className="p-5 text-center ocaklarimiz" id="antalyaelmali1">
      <div className="container" style={{ marginTop: "5rem" }}>
        <SectionTitle title={t("ANTALYA ELMALI - 1")} />
      </div>

      <div className="row row-cols-1 row-cols-md-3 g-4">
        <div className="col mb-4">
          <QuarriesCard
            link="/elmalicosmosbeige"
            title={t("Cosmos Beige")}
            picture="/assets/img/Cosmos-Beige.webp"
            company="Elmalı Madencilik İnş. Ltd. Şti."
          />
        </div>

        <div className="col mb-4">
          <QuarriesCard
            link="/elmalicloudybeige"
            title={t("Cloudy Beige")}
            picture="/assets/img/Elmalı Cloudy Beige Slabs-6.webp"

            company="Elmalı Madencilik İnş. Ltd. Şti."
          />
        </div>

        <div className="col mb-4">
          <QuarriesCard
            link="/elmalibaiyulan"
            title={t("Elmalı Baiyulan")}
            picture="/assets/img/Baiyulan.webp"
            company="Elmalı Madencilik İnş. Ltd. Şti."
          />
        </div>

      </div>
    </section>
  );
}

export default QuarriesAntalyaElmali1;